import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import validator from 'validator';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import { MdClose } from 'react-icons/lib/md';

import { changePassword } from '../../../services/authServices';
import blockProps from '../../../utils/blockProps';
import Loader from '../../Loader';

class ChangePasswordForm extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func,
  };

  static defaultProps = {
    onCancel: () => {},
  };

  state = {
    newPassword: '',
    newPasswordErrorMessage: null,
    confirmPassword: '',
    confirmPasswordErrorMessage: null,
    loading: false,
    snackbarOpened: false,
    snackbarMessage: '',
    formError: false,
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpened: false,
      snackbarMessage: '',
      formError: false,
    });
  };

  validateForm = () => {
    const errors = {};
    if (validator.isEmpty(this.state.newPassword)) {
      errors.newPasswordErrorMessage = 'Field is required';
    }
    if (validator.isEmpty(this.state.confirmPassword)) {
      errors.confirmPasswordErrorMessage = 'Field is required';
    }
    if (this.state.newPassword !== this.state.confirmPassword) {
      errors.confirmPasswordErrorMessage = "password doesn't match";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ ...errors });
      return false;
    }
    return true;
  };

  submitPasswordChangeRequest = async () => {
    if (this.validateForm()) {
      this.setState({ loading: true });
      try {
        await changePassword(this.state.newPassword);
        this.setState(
          {
            loading: false,
            snackbarOpened: true,
            snackbarMessage: 'password successfully updated',
          },
          () => {
            this.props.onCancel();
          },
        );
      } catch (error) {
        this.setState(
          {
            loading: false,
            snackbarOpened: true,
            snackbarMessage: error.message || 'unable to reset password. please try again.',
            formError: true,
          },
          () => {
            this.props.onCancel();
          },
        );
      }
    }
  };

  render() {
    const { onCancel } = this.props;

    return (
      <div>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            this.submitPasswordChangeRequest();
          }}
        >
          <FormTitle>Change Password</FormTitle>

          <InputsContainer>
            <TextField
              id="new-password"
              placeholder="New Password"
              label="New Password"
              value={this.state.newPassword}
              onChange={(event) => {
                const { value } = event.target;
                this.setState({
                  newPassword: value,
                  newPasswordErrorMessage: null,
                });
              }}
              helperText={this.state.newPasswordErrorMessage}
              error={Boolean(this.state.newPasswordErrorMessage)}
              type="password"
              fullWidth
            />

            <TextField
              id="confirm-password"
              placeholder="Confirm Password"
              label="Confirm Password"
              value={this.state.confirmPassword}
              onChange={(event) => {
                const { value } = event.target;
                this.setState({
                  confirmPassword: value,
                  confirmPasswordErrorMessage: null,
                });
              }}
              helperText={this.state.confirmPasswordErrorMessage}
              error={Boolean(this.state.confirmPasswordErrorMessage)}
              fullWidth
            />
          </InputsContainer>

          <ActionsContainer>
            <Button variant="outlined" color="primary" onClick={onCancel} type="button">
              Close
            </Button>
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </ActionsContainer>
        </Form>

        <Snackbar
          open={this.state.snackbarOpened}
          autoHideDuration={3000}
          onClose={this.handleSnackbarClose}
        >
          <StyledSnackbarContent
            formError={this.state.formError}
            message={this.state.snackbarMessage}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleSnackbarClose}
              >
                <MdClose size={20} />
              </IconButton>,
            ]}
          />
        </Snackbar>

        {this.state.loading && <Loader />}
      </div>
    );
  }
}

export default ChangePasswordForm;

const Form = styled.form``;

const FormTitle = styled(Typography).attrs({
  variant: 'headline',
  gutterBottom: true,
})``;

const InputsContainer = styled.div`
  && {
    & > * + * {
      margin-top: 16px;
    }
  }
`;

const ActionsContainer = styled.div`
  && {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 24px;

    & > * + * {
      margin-left: 16px;
    }
  }
`;

const StyledSnackbarContent = styled(blockProps(SnackbarContent, ['formError']))`
  background-color: ${props => (props.formError ? 'red' : 'green')} !important;
`;



// WEBPACK FOOTER //
// ./src/components/AppShell/components/ChangePasswordForm.js